import PropTypes from 'prop-types';
import { MoreIcon } from '../icons/FeedIcons';

function PostHeader({ user, timestamp }) {
  const initials = user.username
    ? user.username.slice(0, 2).toUpperCase()
    : '??';

  return (
    <div className="flex items-center justify-between p-3">
      <div className="flex items-center gap-3">
        {/* Avatar */}
        <div className="w-8 h-8 rounded-full bg-gray-200 overflow-hidden flex items-center justify-center">
          {user.avatarUrl ? (
            <img
              src={user.avatarUrl}
              alt={user.username}
              className="w-full h-full object-cover"
            />
          ) : (
            <span className="text-xs font-semibold text-gray-500">
              {initials}
            </span>
          )}
        </div>

        {/* Username and timestamp */}
        <div className="flex items-center gap-1">
          <span className="font-semibold text-sm text-puzzle-text">
            {user.username}
          </span>
          <span className="text-puzzle-text-secondary text-sm">
            {`• ${timestamp}`}
          </span>
        </div>
      </div>

      {/* More options button */}
      <button
        type="button"
        className="p-1 hover:opacity-60 transition-opacity"
        aria-label="More options"
      >
        <MoreIcon className="w-5 h-5 text-puzzle-text" />
      </button>
    </div>
  );
}

PostHeader.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string,
    username: PropTypes.string.isRequired,
    avatarUrl: PropTypes.string,
  }).isRequired,
  timestamp: PropTypes.string.isRequired,
};

export default PostHeader;
